module.exports = __webpack_public_path__ + "static/media/arbreSH.dd5b8c96.png";